function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { getReactRoot } from 'oskari-ui/components/window';
import { FileUploadPanel } from './components/FileUploadPanel';
import { LayerDetails } from './components/LayerDetails';
import { ProgressBar } from './components/ProgressBar';
import { FileListing } from './components/FileListing';
import { FileService } from './service/FileService';
import { LayerHelper } from './service/LayerHelper';
var BasicBundle = Oskari.clazz.get('Oskari.BasicBundle');
var flyout = Oskari.clazz.create('Oskari.userinterface.extension.ExtraFlyout', 'Lisää tiedostoja');
flyout.move(170, 0, true);
flyout.makeDraggable();
var mainUI = jQuery('<div></div>');
flyout.setContent(mainUI);
var layer = {};
Oskari.clazz.defineES('Oskari.file-upload.BundleInstance', /*#__PURE__*/function (_BasicBundle) {
  function FileUploadBundle() {
    var _this;
    _classCallCheck(this, FileUploadBundle);
    _this = _callSuper(this, FileUploadBundle);
    _this.__name = 'file-upload';
    _this.eventHandlers = {
      MapLayerEvent: function MapLayerEvent(event) {
        if (event.getOperation() !== 'add') {
          // only handle add layer
          return;
        }
        if (event.getLayerId()) {
          LayerHelper.addLayerTool(event.getLayerId(), showFlyout);
        } else {
          // initial layer load
          LayerHelper.setupLayerTools(showFlyout);
        }
      },
      GetInfoResultEvent: function GetInfoResultEvent(event) {
        addFileListing(event);
      }
    };
    return _this;
  }
  _inherits(FileUploadBundle, _BasicBundle);
  return _createClass(FileUploadBundle, [{
    key: "_startImpl",
    value: function _startImpl() {
      LayerHelper.setupLayerTools(showFlyout);
    }
  }]);
}(BasicBundle));
var eventDetection = [];
function addFileListing(gfiResultEvent) {
  // Hacky way of detecting if we sent this...
  var filtered = eventDetection.filter(function (e) {
    return e !== gfiResultEvent;
  });
  if (filtered.length !== eventDetection.length) {
    // remove from detection
    eventDetection = filtered;
    // Don't react again
    return;
  }
  // Nope, all good, not going to infinity and beyond!
  var _gfiResultEvent$getDa = gfiResultEvent.getData(),
    layerId = _gfiResultEvent$getDa.layerId,
    features = _gfiResultEvent$getDa.features,
    lonlat = _gfiResultEvent$getDa.lonlat;
  var featureId = LayerHelper.getAttachmentFeatureId(layerId, features);
  if (!featureId) {
    // not found
    return;
  }
  FileService.listFilesForFeature(layerId, featureId, function (files) {
    if (!files.length) {
      // no attachments
      return;
    }
    var infoEvent = Oskari.eventBuilder('GetInfoResultEvent')({
      layerId: layerId,
      features: [{
        layerId: layerId,
        presentationType: 'Hack to inject more HTML on GFI popup!',
        content: FileService.getFileLinksForFeature(layerId, files)
      }],
      lonlat: lonlat,
      // just to force "WMS" style parsing
      via: 'ajax'
    });
    eventDetection.push(infoEvent);
    Oskari.getSandbox().notifyAll(infoEvent);
  });
}
function showFlyout(layerId) {
  var maplayer = LayerHelper.getLayerService().findMapLayer(layerId);
  layer = {
    id: maplayer.getId(),
    name: maplayer.getName(),
    attr: maplayer.getAttributes(LayerHelper.KEY_ATTRIBUTES_ATTACHMENT) || 'id'
  };
  FileService.listFilesForLayer(layer.id, function (files) {
    layer = _objectSpread({
      files: files
    }, layer);
    updateUI(layer);
  });
  flyout.show();
  updateUI(layer);
}
function updateUI(layer, progress) {
  getReactRoot(mainUI[0]).render(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LayerDetails, _extends({}, layer, {
    onPropertyChange: function onPropertyChange(value) {
      return changeLayerAttr(value, false);
    },
    onSave: function onSave(value) {
      return changeLayerAttr(value, true);
    }
  })), /*#__PURE__*/React.createElement(FileUploadPanel, {
    onSubmit: submitFiles
  }), /*#__PURE__*/React.createElement(ProgressBar, {
    value: progress || 0
  }), /*#__PURE__*/React.createElement(FileListing, {
    files: layer.files || [],
    layerId: layer.id,
    onDelete: removeFile
  })));
}
function removeFile(layerId, fileId) {
  var r = confirm("Haluatko poistaa tiedoston?");
  if (r === true) {
    FileService.removeFile(layerId, fileId, function () {
      // console.log(`Removed from ${layerId} file ${fileId}`);
      // update file listing
      showFlyout(layer.id);
    });
  }
}
function changeLayerAttr(value, callServer) {
  // save to server
  if (callServer) {
    var maplayer = LayerHelper.getLayerService().findMapLayer(layer.id);
    var attrib = maplayer.getAttributes();
    var oldValue = attrib[LayerHelper.KEY_ATTRIBUTES_ATTACHMENT];
    attrib[LayerHelper.KEY_ATTRIBUTES_ATTACHMENT] = value;
    maplayer.setAttributes(attrib);
    var url = Oskari.urls.getRoute('WFSAttachmentsLayer') + "&layerId=".concat(layer.id, "&attachmentKey=").concat(value);
    jQuery.ajax({
      url: url,
      type: 'PUT',
      // restore old value on error
      error: function error() {
        return changeLayerAttr(oldValue, false);
      }
    });
  }
  layer.attr = value || 'id';
  updateUI(layer);
}
function submitFiles(data) {
  var resetCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  FileService.uploadFiles(layer.id, data.files, function (progress) {
    return updateUI(layer, progress);
  }, function () {
    alert('Tiedostot lisätty');
    resetCB();
    // update file listing
    showFlyout(layer.id);
  }, function () {
    updateUI(layer, 0);
    alert('Virhe tiedostojen siirrossa');
  });
}